export const COIN_ID = "digital-reserve-currency";
